import React from "react";
import {
  ServicesCard,
  ServicesContainer,
  ServicesHeading,
  ServicesP,
  ServicesWrapper,
  ServicesImg,
  Img,
  ServicesH4,
} from "./ServicesStyle";
import Icon1 from "../../images/icon1.svg";
import Icon2 from "../../images/icon2.svg";
import Icon3 from "../../images/icon3.svg";
import Icon4 from "../../images/icon4.svg";
import Icon5 from "../../images/icon5.svg";
import Icon6 from "../../images/icon6.svg";
import Icon7 from "../../images/icon7.svg";
import Icon8 from "../../images/icon8.svg";

const Services = (lightBg) => {
  return (
    <ServicesContainer id="services" lightBg={lightBg}>
      <ServicesHeading>Dev Stack</ServicesHeading>
      <ServicesP></ServicesP>
      <ServicesWrapper>
        <ServicesCard data-aos="fade-right" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon1} />
          </ServicesImg>
          <ServicesH4>MongoDb</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-down-right" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon2} />
          </ServicesImg>
          <ServicesH4>Express JS</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-down-left" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon3} />
          </ServicesImg>
          <ServicesH4>React JS</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-left" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon4} />
          </ServicesImg>
          <ServicesH4>Node JS</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-right" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon5} />
          </ServicesImg>
          <ServicesH4>CSS</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-up-right" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon6} />
          </ServicesImg>
          <ServicesH4>HTML</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-up-left" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon7} />
          </ServicesImg>
          <ServicesH4>Python</ServicesH4>
        </ServicesCard>
        <ServicesCard data-aos="fade-left" data-aos-mirror="true">
          <ServicesImg>
            <Img src={Icon8} />
          </ServicesImg>
          <ServicesH4>MySQL</ServicesH4>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
